export default {
    state: {
        setting: undefined
    },
    getters: {
        setting: state => state.setting,
    },
    mutations: {
        setting(state, setting) {
            console.log(setting);
            state.setting = setting;
        }
    }
}